export default __webpack_public_path__ + "static/sketchApart-f2aa79b9baf5261048039008ee392e8a.svg";